// extracted by mini-css-extract-plugin
export default {"hiddenHeader":"HiddenHeader_hiddenHeader__R82AZ"};